module.exports = __webpack_public_path__ + "img/nodata1.038d382d.png";